import NewPhoneName from '@/components/phoneNames/NewPhoneName'

export default [
  {
    path: '/phoneNames',
    name: 'phoneNames',
    component: NewPhoneName,
    meta: {
      requiresAuth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/phoneNames.js